import React, {FC, useState} from "react";
import {AppBar, Hidden, makeStyles, Toolbar, Button} from "@material-ui/core";
import TopDrawer from "./TopDrawer";
import ButtonGroup from "./ButtonGroup";
import {useLocation} from "react-router-dom";
import AppLogo from "../images/Logo/AppLogo";
import BurgerButton from "../images/Icons/BurgerButton";

const useStyles = makeStyles(theme => ({
    toolbar: {
        padding: 0,
        justifyContent: "space-between",
        width: "100%",
        alignSelf: "center",
        height: 65
    },
    logo: {
        marginLeft: 60,
        padding: 0,
        borderRadius: 5,
        [theme.breakpoints.down("sm")]: {
            marginLeft: 16
        }
    },
    burger: {
        marginRight: 16,
        borderRadius: 5,
        padding: 0
    }
}));


const TopBar: FC = () => {
    const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
    const toggleDrawer = () => setDrawerOpen(!drawerOpen);
    const location = useLocation();
    const classes = useStyles();

    return (
        <AppBar position="static" elevation={0}>
            <TopDrawer isOpen={drawerOpen} toggle={toggleDrawer}/>
            <Toolbar className={classes.toolbar}>
                <Button href={`https://www.ankaufperpost.com${location.search}`} target={"_blank"}
                        className={classes.logo}>
                    <AppLogo/>
                </Button>
                <Hidden mdUp>
                    <Button onClick={toggleDrawer} className={classes.burger}>
                        <BurgerButton/>
                    </Button>
                </Hidden>
                <Hidden smDown>
                    <ButtonGroup location={location}/>
                </Hidden>
            </Toolbar>
        </AppBar>
    );
};

export default TopBar;
